// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G6Hn","question":"styles_question__3wdWI","inputVisibleButton":"styles_inputVisibleButton__z5LtC","note":"styles_note__3p1tz"};